import { render, staticRenderFns } from "./info.vue?vue&type=template&id=079c3c2d&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=079c3c2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079c3c2d",
  null
  
)

export default component.exports